import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 32px 16px 240px 1fr 32px 180px 24px;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
  padding: ${props => props.theme.spacing.sp16} ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.spacing.sp8};

  ${props =>
    props.clickable &&
    css`
      cursor: pointer;

      &:hover {
        background-color: ${props.theme.colors.background.secondary};
      }
    `}
`

export const Position = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const DotContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Dot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.color};
`

export const Label = styled.div`
  min-width: 0;
  overflow: hidden;

  & > * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  height: ${props => props.theme.size.S};
  border-radius: ${props => props.theme.spacing.sp4};
  background-color: ${props => props.theme.colors.disabled.surface};
  overflow: hidden;
`

export const BarFill = styled.div`
  height: 100%;
  width: ${props => props.width}%;
  min-width: ${props => (props.width > 0 ? '2px' : '0')};
  background-color: ${props => props.color};
  border-radius: ${props => props.theme.spacing.sp4};
  flex-shrink: 0;
`

export const BarPercentage = styled.div`
  flex-shrink: 0;
`

export const Count = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const SentimentContainer = styled.div`
  display: flex;
  align-items: center;
`

export const ChevronContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  visibility: hidden;

  ${Container}:hover & {
    visibility: visible;
  }
`
